import React from "react";
import { Card, CardTitle, CardDescription } from "campaign-builder/ui";
import { FieldLabel } from "./fields";
import { CitySelect } from "./CitySelect";
import { MapContainer } from "./MapContainer";
import { DistributionAreasSection } from "./DistributionAreasSection";

// Shared Targeting card (AC18-AC20): city dropdown, the map region (empty /
// loading / ready states), and the distribution-areas list below it. The
// channel-specific map content is passed as children — H2H pins (F4) / D2D
// polygons (F5); with none, the map shows a neutral ready placeholder.
export const TargetingCard = ({ children }: { children?: React.ReactNode }) => (
  <Card className="flex flex-col gap-5 p-[25px]" data-targeting-section="city-map">
    <div className="flex flex-col gap-2">
      <CardTitle data-cypress-id="targetingTitle">Targeting</CardTitle>
      <CardDescription data-cypress-id="targetingBody">
        Select the city where your campaign will take place.
      </CardDescription>
    </div>
    <div className="flex flex-col gap-1">
      <FieldLabel data-cypress-id="citySelectTitle">City</FieldLabel>
      <CitySelect />
    </div>
    <MapContainer>{children}</MapContainer>
    <DistributionAreasSection />
  </Card>
);
